import React, { useState } from 'react';
import { Tabs, TabList, TabPanels, Tab, TabPanel } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import Form from './Form';

const ProductTable: React.FC = () => {
  const [tabIndex, setTabIndex] = useState(0);
  const { t } = useTranslation();
  return (
    <Tabs index={tabIndex} onChange={index => setTabIndex(index)}>
      <TabList>
        <Tab>{t('data')}</Tab>
      </TabList>
      <TabPanels>
        <TabPanel>
          <Form
            onCreated={() => {
              setTabIndex(1);
            }}
          />
        </TabPanel>
      </TabPanels>
    </Tabs>
  );
};

export default ProductTable;
